<script setup lang="ts">
import { useTimesheetStore } from '@/stores/timesheets';
import { useRosterStore } from '@/stores/rosters';
import { getTranslations } from '@/lib/util/i18n';
import { displayFromISO, displayFromSeconds } from '@/lib/util/dateTime';
import ShiftDetailLineItem from './ShiftDetailLineItem.vue';

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'shift-details',
});

const timesheets = useTimesheetStore();
const rosters = useRosterStore();
</script>

<template>
  <div class="shift-details">
    <div v-if="timesheets.isOnShift">
      <ShiftDetailLineItem
        v-if="!rosters.getRosterForActiveTimesheet()"
        icon="clock"
        :infoContent="false"
        ><template #main-content>{{
          t('shift-start-time', {
            startShiftTime: displayFromISO(timesheets.getStartShiftTime()),
          })
        }}</template></ShiftDetailLineItem
      >
      <ShiftDetailLineItem v-else icon="clock" :info-content="true"
        ><template #main-content>{{
          t('shift-roster-time', {
            startShiftTime: displayFromSeconds(rosters.getStartRosterTime()),
            endShiftTime: displayFromSeconds(rosters.getEndRosterTime()),
          })
        }}</template
        ><template #info-content>{{
          t('shift-start-time', {
            startShiftTime: displayFromISO(timesheets.getStartShiftTime()),
          })
        }}</template></ShiftDetailLineItem
      >
    </div>
    <div
      v-else-if="!timesheets.isOnShift && rosters.getNextRosterForActiveUser()"
    >
      <ShiftDetailLineItem
        v-if="!rosters.getRosterForActiveTimesheet()"
        icon="clock"
        :info-content="false"
        ><template #main-content>{{
          t('shift-roster-time', {
            startShiftTime: displayFromSeconds(rosters.getStartRosterTime()),
            endShiftTime: displayFromSeconds(rosters.getEndRosterTime()),
          })
        }}</template></ShiftDetailLineItem
      >
    </div>
  </div>
</template>

<style>
.shift-details .__details-item {
  margin-left: 2px;
}
</style>
